import type { AuthErrorCode } from '@volee/auth'

// What a failure of the auth flow reads like — the SOURCE. Indexed by a code the app does
// not choose, so it gets its own catalogue rather than keys in ui.ts.
export const EN_AUTH_ERRORS: Record<AuthErrorCode, string> = {
  // The three that must not differ: telling an unknown email from a wrong password turns
  // the form into an oracle of which accounts exist.
  invalid_credentials: 'Email or password is not correct.',
  user_not_found: 'Email or password is not correct.',
  user_not_confirmed: 'Email or password is not correct.',

  password_rejected: 'This password does not meet the requirements.',
  code_mismatch: 'This code is not correct.',
  code_expired: 'This code has expired. Ask for a new one.',
  rate_limited: 'Too many attempts. Wait a few minutes and try again.',
  password_reset_required: 'This password has to be reset before you can sign in.',
  challenge_expired: 'It took too long. Start again from the sign-in page.',
  invalid_parameter: 'Some of the data entered is not valid.',
  // Only the AWS console can enrol MFA, so this is a real account in a state we cannot drive.
  challenge_unsupported: 'This account needs a step this app cannot handle. Ask an administrator.',
  scope_insufficient: 'This session cannot change the password. Sign out and sign in again.',
  idp_request_failed: 'The sign-in service did not answer. Try again shortly.',

  // The hosted-UI half: apps/frontend's flow, still reachable from a stale link here.
  state_mismatch: 'Sign-in could not be verified. Try again.',
  verifier_missing: 'Sign-in could not be verified. Try again.',
  callback_error: 'Sign-in could not be completed. Try again.',
  token_request_failed: 'Sign-in could not be completed. Try again.',
  id_token_missing: 'Sign-in could not be completed. Try again.',
  refresh_failed: 'Your session has ended. Sign in again.',
  no_refresh_token: 'Your session has ended. Sign in again.',
  crypto_unavailable: 'This browser cannot sign you in securely. Update it, or use another one.',
  delegation_unavailable:
    'Your child’s account cannot be added to this phone yet. Try again later.',
  delegation_refused: 'Your child’s account could not be added. Try again.',
}
